module.exports = __webpack_public_path__ + "img/51_60.50410c55.png";